<template>
  <section class="levels">
    <div class="wrapper" v-if="levels.length>0">
      <div class="wrapper__levels" v-if="dialogRegisterVisible">
        <div class="wrapper__levels--body" :style="myStyle">
         <span class="closeWindows" @click="cancel()"><i class="fa fa-times" aria-hidden="true"></i></span>
           <h1><span class="sign" v-if="lang=='es'">¿ </span> {{$t("whatGrade")}}  <span class="sign"> ?</span> </h1>
           <ul>
              <!--<h1 class="">{{ levelName }}</h1>-->
              <li v-for="(grade, index) in grades" :key="grade.id" class="grades-link">
              <router-link :to="{ name: 'grade', params: { grade_id: grade.id, level: levelIndex } }" @click.native="actividad(grade)">
                <!--<span class="index" :style="myStyle">{{index + 1}}</span> {{grade.name.find(item => item.lang === lang).value}}-->
                <img :src="grade.name.find(item => item.lang=== lang).img" alt="">
              </router-link>
              </li>
              </ul>
              <h1 class="title">{{ levelName }}</h1>
        </div>
      </div>
      <div class="wrapper__banner object">
        <div class="wrapper__banner-img-left">
          <img class="img"  src="@/assets/TPM_yourpath.svg" alt="tpm logo" />
           <!--<h1 class="title">{{ $t("bannerTitle") }}</h1>-->
           <!--<p class="subtitle">{{ $t("bannerText") }}</p>--> 
           <p class="subtitle">{{educationalQuote}}</p> 
        </div>
        <img class="wrapper__banner-img-rigth" src="@/assets/TPM-banner-rigth.svg" />
          <EducationalQuotesComponet @eventRamdomQuote="getEducationalQuote"/>
      </div>
      <!--New menu-->
        <div class="wrapper__level">
          <button class="button" @click="onBtnNextClick(0)" :disabled="disabledButton">
            <i class="fa fa-caret-left" aria-hidden="true" ></i>
          </button>
          
          <ul class="wrapper__level--list">
              <li class="list__item" :id="'_'+index" v-for="(level, index) in levels" :key="level.id" @click="onLevelClick(level.grades, level.name.find(item => item.lang === lang).value,index)">
                <div v-if="level.grades != null" class="nivel" :class="colorsMain[index].name">
                  <div v-if="level.path != 'high-school'">
                    <div class="wrap__img">
                      <img class="circulo" src="@/assets/circulo.svg" alt="">
                      <img class="img" :src="level.icon"/>
                      <!--<img class="img" src="@/assets/nivel3.png" />-->
                    </div>
                    <div class="wrap__h1">
                      <!--<h1 class="text-center">{{ level.name.find(item => item.lang === lang).value }}</h1>
                      <h1 class="title"></h1>-->
                      <img :src="level.name.find(item => item.lang === lang).img" alt="">
                    </div>
                      <!-- seccion reemplazada con wrapper__levels -->
                  </div>
                  <div class="" v-else>
                  <!--<div class="" v-else  @click="highSchool(level.grades[0].id)">-->
                    <div class="wrap__img">
                      <img class="circulo" src="@/assets/circulo.svg" alt="">
                      <img class="img" src="@/assets/nivel3.png" />
                    </div>
                    <div class="wrap__h1">
                      <!--<h1 class="text-center">{{ level.name.find(item => item.lang === lang).value }}</h1>
                      <h1 class="title"></h1>-->
                      <img :src="level.name.find(item => item.lang === lang).img" alt="">
                    </div>
                  </div>
                </div>
              </li>
              <!--v-if="userAuthenticated.can_state_exams"-->
              <li class="list__item" :id="'_'+4" :style="styleTest1" @click.prevent="stateExam">
                <div class="nivel">
                  <div>
                    <div class="wrap__img">
                      <img class="circulo" src="@/assets/test_icon_ccss.svg" alt="">
                      <img class="img"/>
                    </div>
                    <div class="wrap__h1">
                        <img class="img" src="@/assets/State_test_Practice.svg" />
                    </div>
                  </div>
                </div>
              </li>
              <li class="list__item" :id="'_'+5" :style="styleTest2" @click="satExam">
                <div class="nivel">
                  <div>
                    <div class="wrap__img">
                      <img class="circulo" src="@/assets/test_icon_sat.svg" alt="">
                       <img class="img"/>
                    </div>
                    <div class="wrap__h1">
                          <img class="img" src="@/assets/SAT_Practice.svg" />
                    </div>
                  </div>
                </div>
              </li>
              <li class="list__item" :id="'_'+6" :style="styleTest3"  @click="gedExam">
                <div class="nivel">
                  <div>
                    <div class="wrap__img">
                      <img class="circulo" src="@/assets/test_icon_ged.svg" alt="">
                      <img class="img"/>
                    </div>
                    <div class="wrap__h1">
                      <img class="img" src="@/assets/GED_Practice.svg" />
                    </div>
                  </div>
                </div>
              </li>
          </ul>
          <button class="button" @click="onBtnNextClick(1)" :disabled="disabledButton">
          <i class="fa fa-caret-right" aria-hidden="true" ></i>
          </button>
        </div>
        <div class="wrapper__indicators" v-if="showIndicators">
          <span v-for="(item, index) in lista" class="wrapper__indicators--span" @click="onIndicatorClick(index +1 )"></span>
        </div>
      <!--end New menu-->
    </div>
  </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import MenuIcon from '@/layouts/components/MenuIcon.vue';
import SubMenuIcon from '@/layouts/components/SubMenuIcon.vue';
import swal from 'sweetalert';
import i18n from "@/i18n/i18n";
import EducationalQuotesComponet from './EducationalQuotes.vue'
export default {
  name: 'Main',
  components:{
    MenuIcon,
    SubMenuIcon,
    EducationalQuotesComponet
  },
  data() {
    return {
      /** Almacena el nombre de las clases de colores para representar cada nivel */
      colorsMain: [{ name: 'ligth-blue', cod:"#80c6db" }, 
      { name: 'green', cod:"#73b243" }, { name: 'orange', cod:"#de6433" }, 
      { name: 'blue', cod:"#3960a5" },{ name:'yellow', cod:"#f3ad31"}],
      gradeId: null,
      levels: [],
      hidden: true,
      grades:null,
      dialogRegisterVisible: false,
      levelName: null,
      myStyle:{
            backgroundColor:"#16a085" 
            },
      styleTest1:{
        backgroundImage: `url(${require("../../assets/fondo_test_1.svg")})`, 
        color: `#f3ad31`
      },
      styleTest2:{
        backgroundImage: `url(${require("../../assets/fondo_test_2.svg")})`,
         color: `#73b243`
      },
      styleTest3:{
        backgroundImage: `url(${require("../../assets/fondo_test_3.svg")})`,
         color: `#de6433`
      },
      itemId:1,
      lista: [],
      itemIdBtn:2,
      lstCtrlEffect:[],
      showIndicators: false,
      disabledButton: false,
      levelIndex:0,
      educationalQuote:'',
    };
  },
  computed: {
    ...mapGetters({
      userAuthenticated: 'userAuthenticated',
      lang: 'app/language',
      activityIdCurrent: 'activity/activityIdCurrent',
      gradeActivityIdCurrent: 'gradeActivity/activityIdCurrent',
      gradeActivityTimeInSeconds: 'gradeActivity/timeInSeconds',
      currentLevel: 'getCurrentLevel',
    }),
  },
  watch: {
    language() {
      this.getAllNivels();
    }
  },
  beforeDestroy() {
    this.$store.commit('SIDEBAR_ACTIVE_CLASS', { item: 'Home', active: false });
  },
  created() {
    this.$store.commit('SHOW_PROGRESS_BAR', false);
    this.$store.commit('showSidebar', true);
    this.$store.commit('SIDEBAR_ACTIVE_CLASS', { item: 'Home', active: true });
    /** Resetea el valor de array currentGrade de $store.state para sobre escribir el nuevo contenido del grado seleecionado */
    this.$store.commit('SET_GRADE_DATA', []);
    this.getAllNivels();
  },
  updated(){
    //let element_0 = document.getElementById("_1")
    //element_0.classList.toggle("mi-prueba", true);
    if(!this.userAuthenticated.can_state_exams){
      let elementStateExam = document.getElementById("_4")
      elementStateExam.classList.toggle("can-not-take-exam", true);
    }
    this.lista = document.getElementsByClassName("list__item");
  },
  methods: {
    ...mapActions({
      updateBreadCrumb: 'updateBreadCrumb',
      updateGradeActivity: 'gradeActivity/FETCH_UPDATE',
      createGradeActivity: 'gradeActivity/FETCH_CREATE',
    }),
    onCreateGradeActivity() {
      this.createGradeActivity({
        data: {
          grade_id: this.gradeId,
          activity_id: this.activityIdCurrent,
        },
      });
    },
    onUpdateGradeActivity() {
      this.updateGradeActivity({
        id: this.gradeActivityIdCurrent,
        data: {
          time_active: this.gradeActivityTimeInSeconds,
        },
      }).then(() => {
        this.onCreateGradeActivity();
      });
    },
    actividad(grade) {
      this.gradeId = grade.id;
      this.$store.commit('SET_CURRENT_GRADE', grade);
      this.onUpdateGradeActivity();
    },
    /** Redirecciona al componente signUp, para registrar un nuevo usuario */
    showModalSignUp(payload) {
      this.$store.commit('SHOW_OR_HIDDEN_MODAL_REGISTER_NEW_STUDENT', payload);
    },
    getAllNivels() {
      this.$store.commit('app/START_PROCESSING');
      this.$httpMain
        .get(`levels`)
        .then(res => {
          this.levels = res.data;
          for (let index = 0; index < this.levels.length; index++) {
            const element = this.levels[index];
            let idx=1;
            switch (index) {
              case 0:
                //set svg of level name
                element.name.forEach(el => {
                    if(idx===1){
                      el['img']=`${require("../../assets/levels_names/en/Lower_Elementary_School.svg")}`

                    }else{
                      el['img']=`${require("../../assets/levels_names/es/Escuela_primaria_inferior.svg")}`
                    }
                    idx+=1;
                }); 
                // set svg of grade name
                for (let i = 0; i < element.grades.length; i++) {
                  const el = element.grades[i];
                  let subIndice=1;
                  switch(i){
                    case 0:
                      el.name.forEach(el => {
                        if(subIndice===1){
                          el['img']=`${require("../../assets/grades_name/en/icono_pk.svg")}`;
                        }else{
                          el['img']=`${require("../../assets/grades_name/en/icono_pk.svg")}`
                        }
                        subIndice+=1;
                      })
                      break;
                    case 1:
                      el.name.forEach(el => {
                        if(subIndice===1){
                          el['img']=`${require("../../assets/grades_name/en/icono_k.svg")}`;
                        }else{
                          el['img']=`${require("../../assets/grades_name/en/icono_k.svg")}`
                        }
                        subIndice+=1;
                      })
                      break;
                    case 2:
                      el.name.forEach(el => {
                        if(subIndice===1){
                          el['img']=`${require("../../assets/grades_name/en/icono_G1_ing.svg")}`;
                        }else{
                          el['img']=`${require("../../assets/grades_name/es/icono_G1_esp.svg")}`
                        }
                        subIndice+=1;
                      })
                      break;
                    case 3:
                      el.name.forEach(el => {
                        if(subIndice===1){
                          el['img']=`${require("../../assets/grades_name/en/icono_G2_ing.svg")}`;
                        }else{
                          el['img']=`${require("../../assets/grades_name/es/icono_G2_esp.svg")}`
                        }
                        subIndice+=1;
                      })
                      break;
                    default:
                      break;
                  }
                }
              break;
              case 1:
                element.name.forEach(el => {
                    if(idx===1){
                      el['img']=`${require("../../assets/levels_names/en/Upper_Elementary_School.svg")}`
                    }else{
                      el['img']=`${require("../../assets/levels_names/es/Escuela_primaria.svg")}`
                    }
                    idx+=1;
                }); 
                for (let i = 0; i < element.grades.length; i++) {
                  const el = element.grades[i];
                  let subIndice=1;
                  switch(i){
                    case 0:
                      el.name.forEach(el => {
                        if(subIndice===1){
                          el['img']=`${require("../../assets/grades_name/en/icono_G3.svg")}`;
                        }else{
                          el['img']=`${require("../../assets/grades_name/es/icono_G3.svg")}`
                        }
                        subIndice+=1;
                      })
                      break;
                    case 1:
                      el.name.forEach(el => {
                        if(subIndice===1){
                          el['img']=`${require("../../assets/grades_name/en/icono_G4.svg")}`;
                        }else{
                          el['img']=`${require("../../assets/grades_name/es/icono_G4.svg")}`
                        }
                        subIndice+=1;
                      })
                      break;
                    case 2:
                      el.name.forEach(el => {
                        if(subIndice===1){
                          el['img']=`${require("../../assets/grades_name/en/icono_G5.svg")}`;
                        }else{
                          el['img']=`${require("../../assets/grades_name/es/icono_G5.svg")}`
                        }
                        subIndice+=1;
                      })
                      break;
                    default:
                      break;
                  }
                }
                break;
              case 2:
                element.name.forEach(el => {
                    if(idx===1){
                      el['img']=`${require("../../assets/levels_names/en/Middle_school.svg")}`
                    }else{
                      el['img']=`${require("../../assets/levels_names/es/Escuela_secundaria.svg")}`
                    }
                    idx+=1;
                });
                for (let i = 0; i < element.grades.length; i++) {
                  const el = element.grades[i];
                  let subIndice=1;
                  switch(i){
                    case 0:
                      el.name.forEach(el => {
                        if(subIndice===1){
                          el['img']=`${require("../../assets/grades_name/en/icono_G6.svg")}`;
                        }else{
                          el['img']=`${require("../../assets/grades_name/es/icono_G6.svg")}`
                        }
                        subIndice+=1;
                      })
                      break;
                    case 1:
                      el.name.forEach(el => {
                        if(subIndice===1){
                          el['img']=`${require("../../assets/grades_name/en/icono_G7.svg")}`;
                        }else{
                          el['img']=`${require("../../assets/grades_name/es/icono_G7.svg")}`
                        }
                        subIndice+=1;
                      })
                      break;
                    case 2:
                      el.name.forEach(el => {
                        if(subIndice===1){
                          el['img']=`${require("../../assets/grades_name/en/icono_G8.svg")}`;
                        }else{
                          el['img']=`${require("../../assets/grades_name/es/icono_G8.svg")}`
                        }
                        subIndice+=1;
                      })
                      break;
                    default:
                      break;
                  }
                } 
                break;
                case 3:
                element.name.forEach(el => {
                    if(idx===1){
                      el['img']=`${require("../../assets/levels_names/en/High_School.svg")}`
                    }else{
                      el['img']=`${require("../../assets/levels_names/es/Secundaria.svg")}`
                    }
                    idx+=1;
                }); 
                break;
              default:
                break;
            }    
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$store.commit('app/STOP_PROCESSING');
        });
    },
    highSchool(id) {
      console.log(id);
      this.$router.push({ name: 'grade', params: { grade_id: id, level: this.levelIndex } });
    },
    stateExam() {
      if(this.userAuthenticated.can_state_exams){
        const token = this.$store.state.cookie;
        window.location.href = `http://state-exams.mytpm.org/tpmLogin/${token}`;
      }else{
        console.log("can't take examn");
        swal({
          text: i18n.t("canTakeExam"),
          icon: 'warning',
          buttons:"ok",
          dangerMode: true,
        })
      }
    },
    onSeeCourse(courseName){
      this.hidden = !this.hidden;
      this.handleGrow(this.hidden,courseName)
    },
    handleGrow(isHidden,courseName){
       var element = document.getElementById("_"+courseName);
      if(isHidden){
        element.classList.add('hide');
        for (let index = 0; index < this.levels.length+1; index++) {
          if(index!==courseName){
            var hideElement = document.getElementById('_'+index);
            hideElement.style.display='none';
          }        
        }
      }else{
        element.classList.remove('hide');
         for (let index = 0; index < this.levels.length+1; index++) {
            var hideElement = document.getElementById('_'+index);
            hideElement.style.display='unset';
        }
      }
    },
    onBtnNextClick(op){
      this.lstCtrlEffect=[];
      this.myObserver(op);
      const container = document.querySelector('.wrapper__level--list');
      //const lista = document.getElementsByClassName('list__item');
      let widthElement= this.lista[0].offsetWidth + 25;
      let element_0 = document.getElementById("_"+this.itemIdBtn)
        if(op===1 && this.itemIdBtn!==6 ){
            container.scrollLeft += widthElement; 
            this.itemIdBtn+=1;
        }else{ 
          if(this.itemIdBtn>2){
            container.scrollLeft -= widthElement;
            this.itemIdBtn-=1;
          }else{
              container.scrollLeft += widthElement;
              this.itemIdBtn=3;
          }
        }
        this.disabledButton=true;
        setTimeout(() => {
          this.disabledButton=false;
        }, 1000);
    },
    clearClass(lista){
      for (let index = 0; index < lista.length; index++) {
                const element = lista[index];
                element.classList.remove("mi-prueba");
      }
    },
    onLevelClick(grades, titulo, index){
      console.log( index, titulo);
      this.$store.commit('SET_CURRENT_LEVEL', index + 1);
      this.levelIndex=this.currentLevel;
      this.onUpdateGradeActivity();
      if(index<=2){
        this.dialogRegisterVisible=true;
        this.grades=grades;
        this.levelName=titulo;
        this.myStyle.backgroundColor=this.colorsMain[index].cod
      }
      if (index===3){
        this.highSchool(grades[0].id);
      }
    },
     onDialogRegisterVisible(e) {
      this.dialogRegisterVisible = false;
    },
    cancel(){
       this.dialogRegisterVisible = false;
    },
    satExam(){
      window.open(`http://sat.mytpm.org`,`_blank`) ;
    },
    gedExam(){
       window.open(`http://ged.mytpm.org`,`_blank`) ;
    },
    myObserver(op){
     // this.lista = document.getElementsByClassName("list__item");
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if(entry.isIntersecting){
            if (entry.intersectionRatio >= 0.9) {
               this.lstCtrlEffect.push(entry.target)
               this.clearClass(this.lista);
               if(op===1 && this.lstCtrlEffect[2]){
                 this.lstCtrlEffect[2].classList.toggle("mi-prueba", true);
               }else{
                 this.lstCtrlEffect[0].classList.toggle("mi-prueba", true);
               }
                observer.disconnect();
                
              }
          }
        })
      })
      for (var index = 0; index < this.lista.length; index++) {
        const element = this.lista[index];
        observer.observe(element); 
      }
    },
    onIndicatorClick(index){
      let dif;
      const container = document.querySelector('.wrapper__level--list');
      console.log('index : ',index, ' - itemIde: ',this.itemId,' conta9nerWidth: ', container.scrollLeft);
     //  this.lista = document.getElementsByClassName('list__item');
      let widthElement= this.lista[0].offsetWidth + 25;
  
    //  if(index!=this.itemId){
        dif= index-this.itemId;
       // this.itemId=index;
        console.log("aqui dif ", dif); 
          if(index>=2 || index<=5){
            if (container.scrollLeft>0) {
              console.log("scrollleft entramos ", container.scrollLeft);
              container.scroll -=container.scrollLeft
              console.log("scrollleft entramos ", container.scrollLeft);
            }
            console.log(widthElement,' --', index-1);
            container.scrollLeft += (widthElement * (index-1) );
          }
          console.log("scrollleft ", container.scrollLeft);
       // }else{
       /*   if(index<5){
            dif= this.itemId-index;
            console.log('dif ', dif);
            if(dif>1){
              container.scrollLeft -= (widthElement * (dif - 1) );
            }else{
              container.scrollLeft -= (widthElement * (dif) );
            }
          }*/
       // }
            
     console.log('index : ',index," item id" ,this.itemId);
    },
    getEducationalQuote(payload){
        this.educationalQuote = payload.quote;
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

$color-ligth-blue:  #80c6db;
$color-blue:  #3960a5;
$color-green:  #73b243;
$color-orange:  #de6433;
$color-yellow:  #f3ad31;
.mi-prueba {
 transform: scale(1) !important;
 transition: all ease-in 0.5s;
   @media (min-width: 901px) and (max-width: 1920px){
    transform: scale(0.9) !important;
   }

}
.can-not-take-exam {
 background: gray !important;
}
.levels {
  margin-top: 2rem;
  .wrapper{
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    /***************this section is hide until user click in any grades**************** */
    .wrapper__levels {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100vh;
      background-color: rgba(255, 255, 255, 0.8);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1002;
      &--body {
          width: 100%;
          background-color: green;
          border-radius: 50px;
          padding: 1rem;
          filter: drop-shadow(5px 3px 6px rgb(61, 60, 60));
          .closeWindows{
            color: white;
            position: absolute;
            right: 2rem;
            font-weight: bolder;
            cursor: pointer;
            font-size: 2rem;
            top: 3rem;
          }
          ul{
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
           
            .grades-link{ 
              padding: 2rem 0 0; 
              margin-bottom: 1rem;
              border-radius: 15px;
              width: 100%;
              img {
                width: 100%;
              }
            }
          }
          h1{
            color: white;
            text-align: center;
            font-size: 1rem;
            font-family: "FuturaBold", Helvetica, Arial;
            margin: 0 auto;
            padding-bottom: 10px;
            border-bottom-style: solid;
            border-bottom-width: 3.1px;
            width: fit-content;
            .sign{
              font-family: Helvetica, sans-serif ;
            }
          }
          .title {
            font-size: 0.8rem;
            text-transform: uppercase;
            text-decoration: none;
            border-bottom-style: none;
          }
      }
    }
    /*********************************************************************************** */
  }
}
 .wrapper__banner{
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
      position: relative;
      width: 100%;
      min-width: 350px;
      background-color: $color-yellow;
      display: grid;
      grid-template-columns: 2fr 1fr;
       border-radius: 10px;
       &-img-left{
        padding-bottom: 2rem;
        img{
          position: absolute;
          top: -1rem;
          left: 2rem;
          width: 4rem;
        }
        .subtitle {
          font-family: "Futura", Helvetica, Arial;
          padding-top: 2.5rem;
          padding-left: 2rem;
          color: white;
        }
       }
       &-img-rigth{
        width: 7rem;
       }
  }
.wrapper__level {
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: 15% 70% 15%;
  .button {
    color: $color-blue;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 3rem;
    background-color: transparent;
    border: unset;
    i {
      cursor: pointer;
    }
    &:disabled i{
      color: gray;
      cursor: unset;
    }
  }
  &--list {
      position: relative;
      display: flex;
      justify-content: start;
      align-items: center;
      width: 100%;
      overflow-x: scroll;
      overflow-y: hidden;
      &::-webkit-scrollbar {
        display: none;
      }
       scroll-behavior: smooth;
      .list__item {
        transform: scale(0.8);
        &:nth-child(1){
            background-color: $color-ligth-blue;
        }
        &:nth-child(2){
            background-color: $color-green;
        }
        &:nth-child(3){
            background-color: $color-orange;
        }
        &:nth-child(4){
          background-color: $color-blue;
          &:hover h1 {
            cursor: pointer;
          }
        }
        &:nth-child(5){
          background-color: white;
          position: relative;
          background-size: cover;
          background-position: 50% 50%;
          background-repeat: no-repeat;
        }
        &:nth-child(6){
          background-color: rgb(61, 60, 60);
          position: relative;
          background-size: cover;
          background-position: 50% 50%;
          background-repeat: no-repeat;
        }
        &:nth-child(7){
          background-color: #80c6db;
          position: relative;
          background-size: cover;
          background-position: 50% 50%;
          background-repeat: no-repeat;
         // background-image: url('~@/assets/fondo_test_3.svg');
        }
        cursor: pointer;
        min-width: calc(90% / 3);
        filter: drop-shadow(5px 3px 6px rgb(61, 60, 60));
        margin: 1rem;
        min-height: 150px;
        padding: 1rem 0;
        text-align: center;
        color: white;
        border-radius: 10px;
        .nivel {
          display: grid;
          grid-auto-rows: 50% 50%;
          .last__level {
            li {
              background-color: rgba(255, 255, 255, 0.5);
              margin: 5px 5px;
              border-radius: 5px;
              a {
                color: white;
                font-size: 0.9rem;
              }
            }
          }
        }
        .wrap__img {
          position: relative;
          .circulo {
            position: absolute;
            width: 100%;
            padding: 5%;
          }
          .img {
            width: 100%;
            padding: 20%;
          }
        }
        .wrap__h1 {
          position: absolute;
          bottom: 0;
          width: 100%;
          h1 {
            font-weight: bold;
            text-transform: uppercase;
            margin: 0 auto;
            font-size: 10px;
            max-width: 70px;
          }
          .title{
            padding-bottom: 1rem;
          }
          img{
            width: 100%;
            padding: 5px 20px;
          }
        } 
      }
    }
}
.wrapper__indicators {
  width: 100%;
  height: 50px;
  text-align: center;
  margin-top: 2rem;
  &--span {
    background-color: rgba(#3960A5, 0.8);
    padding: 5px 15px;
    margin: 10px;
    border-radius: 50%;
    cursor: pointer;
    &:hover {
      background-color: rgba(#3960A5, 1);
    }
  }
}
@media all and (min-height: 700px){
 .levels{
   height: 80vh;
   display: flex;
   justify-content: center;
   align-items: center;
 }
}
  @media (min-width: 661px) and (max-width: 900px){
    .wrapper__banner{
        &-img-left{
        padding-bottom: 1rem;
        img{
          top: -1.5rem;
          width: 5rem;
        }
        .subtitle {
          padding-top: 3.5rem;
          font-size: 18px;
        }
       }
      &-img-rigth{
        position: absolute;
        top: -3rem;
        right: 0;
        width: 13rem;
      }
    }
    .wrapper__level {
      .button {
        font-size: 5rem;
      }
      &--list {
        .list__item {
          min-height: 220px;
          .nivel .last__level li {
            padding: 10px 10px;
            a {
              font-size: 1rem;
            }
          }
          .wrap__img {
            width: 80%;
            margin: 0 auto;
            .circulo {
            }
            .img {
            }
          }
          .wrap__h1 {
            h1{
              font-size: 0.9rem;
                max-width: 150px;
            }
            
          } 
        }
      }
    }

  }
  @media (min-width: 901px) and (max-width: 1920px){
    .wrapper {
        max-width: 1400px;
    }
    .levels {
        .wrapper {
          .wrapper__levels{
            &--body{
              position: relative;
              width: 60%;
              border-radius: 100px;
              overflow: hidden;
              .closeWindows {
                font-size: 3rem;
                right: 2.5rem;
              }
              ul {
                height: 60%;
                .grades-link img{
                  width: 80%;
                }
              }
              h1 {
                font-size: 2rem;
              }
              .title {
                font-size: 1.2rem;
              }
            }
          }
      }
    }
    .wrapper__banner{
       &-img-rigth{
        position: absolute;
        top: -4rem;
        right: 0;
        width: 13rem;
      }
      .subtitle {
         font-size: 20px;
      }
    }
    .wrapper__level {
      .button {
        font-size: 7rem;
      }
      &--list {
        .list__item {
          min-height: 360px;
          margin: 0 1rem;
          transform: scale(0.7);
          .nivel .last__level li {
            padding: 10px 10px;
            a {
              font-size: 1.3rem;
            }
          }
          .wrap__img {
            width: 85%;
            margin: 0 auto;
            .circulo {
            }
            .img {
            }
          }
          .wrap__h1 {
            h1{
              font-size: 1.2rem;
              max-width: 200px;
            }
          } 
        }
      }
    }
  }
@media (min-width: 1921px) and (max-width: 2023px){
  .wrapper {
    max-width: 1600px;
  }
  .levels {
    .wrapper {
      .wrapper__levels{
        &--body{
          width: 70%;
          border-radius: 150px;
            .closeWindows {
              font-size: 4rem;
              right: 6rem;
            }
            ul {
              height: 60%;
              .grades-link img{
                width: 80%;
              }
            }
            h1 {
              font-size: 3rem;
            }
            .title{
              font-size: 1.9rem;
            }
        }
      }
    }
  }
  .wrapper__banner{
      &-img-left{
        img{
          top: -3rem;
          width: 8rem;
        }
        .subtitle {
          padding-top: 4rem;
          font-size: 24px;
        }
      }
      &-img-rigth{
        position: absolute;
        top: -6rem;
        right: 0;
        width: 18rem;
      }
  }
  .wrapper__level {
    padding-top: 4rem;
     grid-template-columns: 25% 50% 25%;
      .button {
        font-size: 9rem;
      }
      &--list {
        .list__item {
          min-height: 380px;
          .nivel .last__level li {
            padding: 10px 10px;
            a {
              font-size: 1.5rem;
            }
          }
          .wrap__img {
            .circulo {
            }
            .img {
            }
          }
          .wrap__h1 {
            h1{
              font-size: 2rem;
              max-width: 200px;
            }
          }
        }
      }
    }
}
  @media all and (min-width: 2024px){
  .wrapper {
    max-width: 1900px;
  }
  .levels {
    .wrapper {
      .wrapper__levels{
        &--body{
          max-width: 1000px;
          border-radius: 160px;
          .closeWindows {
            font-size: 4rem;
            right: 6rem;
          }
          ul {
            height: 60%;
            .grades-link img{
              width: 80%;
            }
          }
          h1 {
            font-size: 3rem;
            padding-bottom: 2rem;
          }
          .title{
            font-size: 2rem;
          }
        }
      }
    }
  }
     .wrapper__banner{
      &-img-left{
        img{
          top: -3rem;
          width: 8rem;
        }
        .subtitle {
          padding-top: 4rem;
          font-size: 26px;
        }
      }
      &-img-rigth{
        position: absolute;
        top: -6rem;
        right: 0;
        width: 18rem;
      }
     }
     .wrapper__level {
      padding-top: 5rem;
       grid-template-columns: 25% 50% 25%;
      .button {
        font-size: 11rem;
      }
      &--list {
        .list__item {
          position: relative;
          min-height: 450px;
          .nivel {            
            .last__level li {
            padding: 10px 10px;
            a {
              font-size: 1.5rem;
            }
          }
          }
          .wrap__img {
            .circulo {
            }
            .img {
            }
          }
          .wrap__h1 {
            h1{
             font-size: 2rem;
              max-width: 200px;
            }
          }
        }
      }
    }
  }
  
</style>
